import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import { Table } from 'react-bootstrap';

var Config = require('../../../../config');

class ModalComponents extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		
		this.state = {
		    show: false,
		    components:[]
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(donation_id) {
		this.setState({show: true});
		fetch(Config.default.apiGateway.URL+'units/by_donation?donation_id='+donation_id, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(error) {
                swal('¡Error!', error, 'error');
              });
	        }
	    })
		.then(response =>{
			this.setState({components:response});
		}) 
	}


	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_components.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		{this.state.components.map((item, index) =>{            
							return(	
								<div key={index} className="col-xs-12" style={{paddingTop:"3px",paddingLeft:"20px"}}>
									<fieldset>
							            <legend>{item[0].blood_component.component}</legend> 
							          	<div className="col-xs-offset-1 col-xs-10" style={{paddingTop:"20px"}}>
								          	<Table responsive hover>
									          <thead>
									            <tr>
									              <th>No. Unidad</th>
									              <th>Volumen (ml)</th>
									            </tr>
									          </thead>
									          <tbody>
									        	{item.map((unit, index) =>{   
									            	return 	<tr key={"unit_"+unit.unit.id}>
									            				<td>{unit.unit.id}</td>
									            				<td>{unit.unit.volume}</td>
									            			</tr>
									            })}
									        	</tbody>
									        </Table>
							         	</div>
							        </fieldset>
				        		</div>
				        	)
				        })}
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.handleClose}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}
}

export default translate('translations')(ModalComponents);